import axios from "axios";
import { DOMAIN, TOKEN } from "../utils/settings/config";

const api = axios.create({
  baseURL: DOMAIN,
  headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN)}` },
});

export default api;
